import { Fragment } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { useAuth0 } from "@auth0/auth0-react";

// import { useQuery } from "react-query";

import { useUserFarms } from "api/user";
import EanPicker from "components/Util/EanPicker";

export default function Header({ routes, onUpdate }: any) {
  const { user, logout } = useAuth0();
  const location = useLocation();

  const getLocation = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "";
  };

  const farms = useUserFarms(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"]);

  return (
    <header className="bg-white fixed top-0 w-full z-10 drop-shadow-sm">
      <div className="flex justify-between py-4 px-6">
        <div className="flex-shrink-0 flex">
          <div className="flex items-center">
            <button
              type="button"
              className="bg-blue-600 inline-flex items-center justify-center p-2 rounded-sm text-white hover:text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-white mr-3 lg:hidden"
              aria-controls="mobile-menu"
              aria-expanded="false"
              onClick={() => document.body.classList.toggle("nav-open")}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <svg
                className="hidden h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            {/* <img className="h-8" src="https://www.sustainabledatafarming.nl/media/site/e7f48b8928-1615481835/logo-footer.png" alt="Home-Img" /> */}
          </div>
          <h1 className="ml-5 mt-2.5 text-xl text-blue-600 font-['Avenir'] font-bold">{getLocation()}</h1>
        </div>
        <div className="ml-4 flex items-center md:ml-6">
          <EanPicker updateFarmName={onUpdate} />
          <Menu as="div" className="ml-3 relative">
            <div>
              <Menu.Button
                className="max-w-xs bg-gray-800 rounded-full flex items-center text-sm focus:outline-none"
                id="user-menu-button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <span className="sr-only">Open user menu</span>
                <img className="h-8 w-8 rounded-full" src={user.picture} alt="user" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                className="origin-top-right absolute right-0 mt-2 w-48 z-10 rounded-sm shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
              >
                {farms && farms.length ? (
                  <Menu.Item>
                    <NavLink
                      to={`${process.env.PUBLIC_URL}/settings`}
                      className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50"
                      role="menuitem"
                    >
                      Settings
                    </NavLink>
                  </Menu.Item>
                ) : null}

                <Menu.Item>
                  <div className="block px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-50" 
                    onClick={() => {
                      sessionStorage.removeItem("farm_name");
                      logout();
                    }}>
                    Log out
                  </div>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
      {/* <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-blue-600">{getLocation()}</h1>
      </div> */}
    </header>
  );
}
